module.exports = __webpack_public_path__ + "static/media/ic-document.3bb881d8.svg";